import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import Modal from "../../../../../Components/UI/Modal/Modal";
import CloseButton from "../../../../../Components/UI/CloseButton/CloseButton";
import SegmentedControl from "../../../../../Components/UI/SegmentedControl/SegmentedControl";
import Field from "../../../../Settings/Content/Components/Field";

import LockIcon from "../../../../../Components/Icon-SVG/LockIcon";
import DynamicIcon from "../../../../../Components/Icon-SVG/DynamicIcon";

import { RequestCreateAgentGroup } from "../../../../../store/actions/integrationsActions";
import { addNotification } from "../../../../../store/actions/notifierActions";

const OPTIONS = [
  {
    id: "static",
    label: "Static",
    renderIcon: (isActive) => <LockIcon color={isActive ? "white" : "rgb(155, 155, 155"} />,
  },
  {
    id: "dynamic",
    label: "Dynamic",
    renderIcon: (isActive) => <DynamicIcon color={isActive ? "white" : "rgb(155, 155, 155"} />,
  },
];

const DEFAULT_FORM_DATA = {
  name: "",
  description: "",
  client_id_pattern: "",
};

const CreateAgentGroup = ({ showPopup, setShowPopup, selectedHost }) => {
  const dispatch = useDispatch();

  const isLoading = useSelector((state) => state.integrations.createAgentGroupLoading);
  const isSuccess = useSelector((state) => state.integrations.successCreateAgentGroup);

  const [selectedType, setSelectedType] = useState("static");
  const [formInputs, setFormInputs] = useState(DEFAULT_FORM_DATA);

  useEffect(() => {
    if (!isLoading && isSuccess) {
      setShowPopup(false);
      setFormInputs(DEFAULT_FORM_DATA);
    }
  }, [isLoading, isSuccess]);

  const selectHandler = (id) => setSelectedType(id);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormInputs((prevSettings) => ({
      ...prevSettings,
      [name]: value,
    }));
  };

  const createGroupHandler = () => {
    if (isLoading) return;
    if (!formInputs.name) {
      dispatch(
        addNotification({ message: "Name field is required", options: { variant: "error" } }),
      );
      return;
    }
    if (selectedType === "dynamic" && !formInputs.client_id_pattern) {
      dispatch(
        addNotification({
          message: "Client id pattern field is required",
          options: { variant: "error" },
        }),
      );
      return;
    }
    dispatch(RequestCreateAgentGroup({ type: selectedType, ...formInputs, host: selectedHost }));
  };

  return showPopup ? (
    <Modal active={showPopup} setActive={setShowPopup} type="create-agent-group">
      <h2>Create Agent Group</h2>
      <div className="create-agent-group__close-btn">
        <CloseButton onClick={() => setShowPopup(false)} />
      </div>

      <div className="create-agent-group__form">
        <SegmentedControl options={OPTIONS} value={selectedType} onChange={selectHandler} />
        <p className="create-agent-group__explanation">
          {selectedType === "static"
            ? "Manually assign agents after creation."
            : "Automatically match agents using name wildcards."}
        </p>

        <Field
          label="Group Name"
          width="100%"
          value={formInputs.name}
          onChange={(e) => handleInputChange({ target: { name: "name", value: e.target.value } })}
          placeholder="e.g. Win10 Agents"
          name="name"
        />

        <Field
          label="Description (optional)"
          width="100%"
          value={formInputs.description}
          onChange={(e) =>
            handleInputChange({ target: { name: "description", value: e.target.value } })
          }
          placeholder="e.g. All win10 agents"
          name="description"
        />

        {selectedType === "dynamic" ? (
          <Field
            label="Client ID Pattern (wildcard)"
            tooltipText="Use * for any characters, ? for single character"
            width="100%"
            value={formInputs.client_id_pattern}
            onChange={(e) =>
              handleInputChange({ target: { name: "client_id_pattern", value: e.target.value } })
            }
            placeholder="e.g. win10-* or agents-??"
            name="client_id_pattern"
          />
        ) : null}
      </div>

      <div className="create-agent-group__actions">
        <button className="danger-button" onClick={() => setShowPopup(false)}>
          Cancel
        </button>
        <button className="primary-button" onClick={createGroupHandler}>
          Create Group
        </button>
      </div>
    </Modal>
  ) : null;
};

export default CreateAgentGroup;
